import { render, staticRenderFns } from "./ExportTestPaper.vue?vue&type=template&id=10900ef7&"
import script from "./ExportTestPaper.vue?vue&type=script&lang=js&"
export * from "./ExportTestPaper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/views/ExportTestPaper.vue"
export default component.exports